import * as React from 'react';
import type { LucideIcon } from 'lucide-react';

/**
 * Render an icon for feedback components (Alert, Toast).
 *
 * Rules:
 *  - `icon === null`  -> render nothing
 *  - `icon` is truthy -> wrap it in a flex-shrink-0 span (custom icon)
 *  - otherwise        -> render the `DefaultIcon` with standard sizing
 *
 * @param icon       Custom icon node or null
 * @param DefaultIcon The default Lucide icon component for the variant
 * @param iconColor  Tailwind text-color class for the default icon (e.g. 'text-success-700')
 */
export function renderFeedbackIcon(
  icon: React.ReactNode | null | undefined,
  DefaultIcon: LucideIcon,
  iconColor: string,
): React.ReactNode {
  if (icon === null) {
    return null;
  }
  if (icon) {
    return <span className="flex-shrink-0">{icon}</span>;
  }
  return (
    <span className={`flex-shrink-0 ${iconColor}`}>
      <DefaultIcon
        width={20}
        height={20}
        strokeWidth={1.5}
        color="currentColor"
        aria-hidden="true"
      />
    </span>
  );
}
